<div #canvasContainer style="min-width: 1008px; height: 600px" id="container" class="white-bg in-block canvas center relative">
	<me-grid-lines [canvasContainerWidth]="canvasService.canvasContainerWidth"></me-grid-lines>
	<div style="top: 21px; left: 50%" [ngStyle]="{ 'margin-left.px': contentMarginLeft }" class="absolute">
		<me-canvas></me-canvas>
	</div>
</div>
